import React from 'react';
import { Link } from 'react-router-dom';
import { saveRecentSearch } from '../utils/recentSearches';
import { focusRing } from '../styles/ui';

// Quick-search shortcuts, in the approved design's order. Each one is a real
// term the catalog search already answers; the two that are whole admin
// categories (Chicken, Eggs) route straight to their category page instead, so
// the shopper lands on the canonical listing rather than a search result for
// the same thing. See freshnhomely-backend/src/utils/categorySlugs.js for the
// category keys.
export const QUICK_SEARCHES = [
  { label: 'Chicken', categoryKey: 'chicken' },
  { label: 'Eggs', categoryKey: 'eggs' },
  { label: 'Milk' },
  { label: 'Tomato' },
  { label: 'Onion' },
  { label: 'Rice' },
  { label: 'Atta' },
];

const chip = `inline-flex items-center h-6 px-[9px] rounded-full bg-white border border-emerald-100 text-[11px] font-semibold text-emerald-950 shadow-[0_1px_2px_rgba(15,51,24,0.06)] hover:bg-emerald-50 hover:border-emerald-200 transition-colors ${focusRing}`;

const HeroSearch = () => (
  <div className="flex flex-wrap items-center gap-x-[6px] gap-y-2">
    <span className="text-[12px] text-ink-secondary mr-1">Popular:</span>
    {QUICK_SEARCHES.map((item) =>
      item.categoryKey ? (
        <Link key={item.label} to={`/categories/${item.categoryKey}`} className={chip}>
          {item.label}
        </Link>
      ) : (
        <Link
          key={item.label}
          to={`/search?q=${encodeURIComponent(item.label)}`}
          onClick={() => saveRecentSearch(item.label)}
          className={chip}
        >
          {item.label}
        </Link>
      )
    )}
  </div>
);

export default HeroSearch;
